import * as types from '../constants/ActionTypes';

const defaultState = {
  cities: [],
  isLoading: false,
  data: null,
  isPavilionsLoading: false,
  pavilions: null,
  isDocumentsLoading: false,
  documents: null,
  isNewsLoading: false,
  news: null,
  isChessLoading: false,
  chessList: {},
  cells: {},
  selected: {},
  filters: {
    section: [0, 0],
    priceMin: null,
    priceMax: null,
    costMin: null,
    costMax: null
  },
  isTable: true,
  isExtended: false,
  listSort: ['number', true],
  tableScroll: {},
  prevLocation: '',
  isDescriptionHide: false,
  error: null,
  zoom: 1.25
};

const zoomVariants = [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];

const initialState = { ...defaultState };

export default function building(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.SET_CITIES:
      return {
        ...state,
        cities: payload
      };
    case types.LOAD_BUILDING_START:
      return {
        ...state,
        ...(state.data && ~~payload.id === state.data.id ? {} : defaultState),
        zoom: state.zoom,
        isLoading: true,
        cities: state.cities,
      };
    case types.LOAD_BUILDING_SUCCESS:
      return { ...state, data: payload.data, prevLocation: '', isLoading: false };
    case types.LOAD_BUILDING_ERROR:
      return { ...state, error: payload, isLoading: false };

    case types.LOAD_PAVILIONS_START:
      return { ...state, pavilions: null, isPavilionsLoading: true };
    case types.LOAD_PAVILIONS_SUCCESS:
      return {
        ...state,
        pavilions: payload.data,
        isPavilionsLoading: false
      };
    case types.LOAD_PAVILIONS_ERROR:
      return { ...state, error: payload, isPavilionsLoading: false };

    case types.LOAD_DOCUMENTS_START:
      return { ...state, isDocumentsLoading: true };
    case types.LOAD_DOCUMENTS_SUCCESS:
      return {
        ...state,
        documents: payload.data,
        isDocumentsLoading: false
      };
    case types.LOAD_DOCUMENTS_ERROR:
      return { ...state, error: payload, isDocumentsLoading: false };

    case types.LOAD_NEWS_START:
      return { ...state, isNewsLoading: true };
    case types.LOAD_NEWS_SUCCESS:
      return {
        ...state,
        news: payload.data.sort((a, b) => a.dateCreate < b.dateCreate),
        isNewsLoading: false
      };
    case types.LOAD_NEWS_ERROR:
      return { ...state, error: payload, isNewsLoading: false };

    case types.LOAD_CHESS_START:
      return { ...state, isChessLoading: true };
    case types.LOAD_CHESS_SUCCESS:
      return {
        ...state,
        chessList: { ...state.chessList, [payload.id]: payload.data },
        isChessLoading: false
      };
    case types.LOAD_CHESS_ERROR:
      return { ...state, error: payload, isChessLoading: false };

    case types.SET_CHESS_CELLS: {
      return {
        ...state,
        cells: { ...state.cells, [payload.id]: payload.cells },
        selected: state.selected[payload.id] ? state.selected : { ...state.selected, [payload.id]: payload.selected }
      };
    }
    case types.LOAD_OBJECTS_SUCCESS: {
      return {
        ...initialState,
        cities: state.cities
      };
    }

    case types.SET_CELL_SELECTED:
      return { ...state, selected: { ...state.selected, [payload.id]: payload.selected } };

    case types.SET_CHESS_FILTERS:
      return {
        ...state,
        filters: { ...state.filters, ...payload }
      };

    case types.SET_CHESS_TABLE:
      return { ...state, isTable: payload };

    case types.SET_CHESS_EXTENDED:
      return { ...state, isExtended: !state.isExtended };
    case types.SET_ZOOM: {
      if (payload.zoomWithRange) {
        return { ...state, zoom: payload.zoom };
      }
      const currentZoomIndex = zoomVariants.findIndex(zoomVariant => zoomVariant === state.zoom);
      const nextZoomIndex = Math.min(zoomVariants.length - 1, Math.max(0, currentZoomIndex + payload.zoom));
      return { ...state, zoom: zoomVariants[nextZoomIndex] };
    }
    case types.SET_LIST_SORT:
      return { ...state, listSort: payload, tableScroll: {} };

    case types.SET_CHESS_DESCRIPTION_HIDE:
      return { ...state, isDescriptionHide: !state.isDescriptionHide };

    case types.SET_TABLE_SCROLL:
      return { ...state, tableScroll: { ...state.tableScroll, [payload.id]: payload.scroll } };

    case types.SET_PREV_LOCATION:
      return { ...state, prevLocation: payload };

    case types.UPDATE_CHESS_STATE:
      return { ...state, ...payload };

    case types.ADD_TO_FAVORITES_START:
      if (state.data) {
        return { ...state, data: { ...state.data, favorite: true } };
      }
      return state;

    case types.REMOVE_FROM_FAVORITES_START:
      if (state.data) {
        return { ...state, data: { ...state.data, favorite: false } };
      }
      return state;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/building.js